import React, { useContext } from 'react';
// import { Link } from 'react-router-dom';
import { ThemeContext } from '../context/ThemeContext';

const Privacy = () => {
  const { darkMode } = useContext(ThemeContext);
  
  return (
    <div className={`flex-1 flex flex-col ${darkMode ? 'dark' : ''} bg-gray-100 dark:bg-gray-900`}>
      <div className="px-4 sm:px-6 lg:px-8 flex-grow">
        <div className="max-w-4xl mx-auto py-10">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Privacy Policy</h1>
        
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-8">
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Last updated: February 24, 2026
          </p>

          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">1. Introduction</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-6">
            At Stonewall Software, Inc. ("Stonewall Invoicing," "we," "us," or "our"), we respect your privacy and are committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Stonewall Invoicing software and related services.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">2. Information We Collect</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            We collect several types of information from and about users of our software, including:
          </p>
          <ul className="list-disc pl-5 text-gray-700 dark:text-gray-300 mb-6 space-y-2">
            <li>Personal identifiers, such as name, email address, and phone number</li>
            <li>Business information, such as business name, address, and tax ID</li>
            <li>Customer and vehicle information that you input into the software</li>
            <li>Payment information necessary to process transactions</li>
            <li>Usage data, such as how you interact with our software</li>
            <li>Technical data, such as IP address, device information, and operating system</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">3. How We Use Your Information</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            We may use the information we collect for various purposes, including to:
          </p>
          <ul className="list-disc pl-5 text-gray-700 dark:text-gray-300 mb-6 space-y-2">
            <li>Provide, maintain, and improve our software and services</li>
            <li>Process your transactions and send related information</li>
            <li>Send administrative information, such as updates and security alerts</li>
            <li>Respond to your comments, questions, and requests</li>
            <li>Analyze usage patterns and trends to enhance user experience</li>
            <li>Protect against, identify, and prevent fraud and other illegal activity</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">4. Data Security</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-6">
            We implement appropriate technical and organizational measures to protect the security of your personal information. However, please note that no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security of your data.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">5. Your Rights and Choices</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-6">
            Depending on your location, you may have certain rights regarding your personal information, including the right to access, correct, or delete your data. To exercise these rights, please contact us using the information provided in the "Contact Us" section below.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">6. Changes to This Privacy Policy</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-6">
            We may update this Privacy Policy from time to time. Any changes will be posted on this page, and if the changes are significant, we will provide a more prominent notice.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">7. Contact Us</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-6">
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <div className="bg-gray-100 dark:bg-gray-700 p-4 rounded-md">
            <p className="text-gray-700 dark:text-gray-300">
              Stonewall Software, Inc.<br />
              support@stonewallinvoicing.com
            </p>
          </div>
        </div>

        </div>
      </div>
    </div>
  );
};

export default Privacy;